import React, { useEffect } from 'react'

const useClickOutside = (ref, handler) => {
useEffect(()=>{
    const listner = event =>{
        const el = ref?.current


        if(!el || el.contains(event.target)){
            return;

        }
        handler(event)
    }
        document.addEventListener("mousedown", listner)
        document.addEventListener("touchstart", listner)
        return()=>{
            document.removeEventListener("mousedown", listner)
            document.removeEventListener("touchstart", listner)
        }
    

},[ref, handler])
}

export default useClickOutside